import { defineStore } from 'pinia'

export const useBreadcrumbStore = defineStore('breadcrumb2', () => {
  const label = ref<string | null>(null)
  const title = ref<string | null>(null)
  const subtitle = ref<string | null>(null)

  function set(payload: { label?: string; title?: string; subtitle?: string }) {
    if ('label' in payload) label.value = payload.label ?? null
    if ('title' in payload) title.value = payload.title ?? null
    if ('subtitle' in payload) subtitle.value = payload.subtitle ?? null
  }

  function reset() {
    label.value = null
    title.value = null
    subtitle.value = null
  }

  return { label, title, subtitle, set, reset }
})
